<button type="button" class="header" [attr.aria-expanded]="!collapsed()" (click)="toggleCollapse.emit()">
    <span>{{ label() }}</span>
    <cl-icon [icon]="icons.ChevronDown" class="chevron" [class.collapsed]="collapsed()" />
</button>
